import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseCrudService, HttpService } from '@nebula-shared/data-access';

@Injectable({ providedIn: 'root' })
export class ImportDialogModalService extends BaseCrudService<any> {
  private httpService = inject(HttpService);

  constructor() {
    super();
  }

  /**
   * Descarga la plantilla del importar.
   *
   * @param endpoint ruta de la plantilla (`GET .../import/plantilla`).
   * @returns el archivo.
   */
  descargarPlantilla(endpoint: string): Observable<Blob> {
    return this.httpService.getBlob(endpoint);
  }

  bulkUpload(file: File, endpoint: string, fieldName = 'archivo'): Observable<any> {
    const formData = new FormData();
    formData.append(fieldName, file, file.name);

    return this.httpService.post<any>(endpoint, formData).pipe(
      map((response: any) => {
        return response?.response?.content || response?.content || response;
      }),
    );
  }

  uploadFileWithData(
    file: File,
    endpoint: string,
    additionalData?: Record<string, any>,
    fieldName = 'archivo',
  ): Observable<any> {
    const formData = new FormData();
    formData.append(fieldName, file, file.name);

    if (additionalData) {
      Object.entries(additionalData).forEach(([key, value]) => {
        formData.append(key, value);
      });
    }

    return this.httpService.post<any>(endpoint, formData).pipe(
      map((response: any) => {
        return response?.response?.content || response?.content || response;
      }),
    );
  }
}
